import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/Card/Card';
import { Button } from '@/components/ui/Button/Button';
import { PageHeader } from '@/components/ui/PageHeader/PageHeader';
import { PageContainer } from '@/components/ui/PageContainer';

export function DangerPage() {
  return (
    <PageContainer>
      <PageHeader 
        title="Danger Zone" 
        description="Irreversible and destructive actions" 
      />

      <div className="space-y-6">
        {/* Content */}
      <Card>
        <CardHeader>
          <CardTitle>Account Deactivation</CardTitle>
          <CardDescription>Permanently deactivate your account and delete all data</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Deactivation will sign you out everywhere and restrict access. Organization ownership may prevent deactivation.</p>
        </CardContent>
        <CardFooter>
          <Button variant="danger" disabled>Deactivate account (coming soon)</Button>
        </CardFooter>
      </Card>
      </div>
    </PageContainer>
  );
}


